import { Component, OnInit } from '@angular/core';
import { baseMenuItems,options } from '../configoptions';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { BaseComponentConfig, ViewContainersService, UpdateComponentStoreService, UbsComponentStoreService, ActionState, ComponentConfig } from '@urbannex/view-containers';

@Component({
  selector: 'ubs-purchase-order',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./purchase-order.component.scss']
})
export class PurchaseOrderComponent extends BaseComponentConfig implements OnInit {
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService,
    private componentStore:UbsComponentStoreService) { 
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    }
    ngOnInit(): void {
      options.defaultAction =  ActionState.LIST;
      options.listForm.findParameters.push({"view_SALES_ORDER":"N"});
      options.listForm.findParameters.push({"view_PURCHASE_ORDER":"Y"});
      options.listForm.findParameters.push({"viewcreated": "Y"});
      options.listForm.findParameters.push({"viewprocessing": "Y"});
      options.listForm.findParameters.push({"viewapproved": "Y"});
      this.componentConfig = new ComponentConfig(options);
      let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuTag = menuAndTitleOptions.menuTag;
      let menuItems:NbMenuItem[] = [];
      baseMenuItems.forEach(item => {
        menuItems.push(item);
      });
      this.menuService.addItems(menuItems,menuTag);
    }
}
